// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.9999 1.76416L21.9458 21.656L11.9999 18.5479L2.05396 21.656L11.9999 1.76416Z"}}]};

const NavigationArrowFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'navigation-arrow-filled',
    ref,
    icon: element,
  },
));

NavigationArrowFilledIcon.displayName = 'NavigationArrowFilledIcon';

export default NavigationArrowFilledIcon;
